import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components/Icons';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0.5, 1),
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: theme.spacing(0.75),
    justifyContent: 'space-between'
  },
  matchText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  delaStarIcon: {
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(1.5)
  }
}));

export const ResourceRequestMatchItemLoading = ({ dataQeId }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div
      data-qe-id={
        dataQeId ? `${dataQeId}_ResourceRequestMatchItemLoading` : undefined
      }
      className={classes.root}
    >
      <div className={classes.matchText}>
        <Typography variant="caption" color="textPrimary">
          {formatMessage({
            id: 'resourceAllocationItem.match'
          })}
        </Typography>
        <DelaStarIcon className={classes.delaStarIcon} />
      </div>
      <Typography variant="body1" color="textSecondary">
        {formatMessage({
          id: 'resourceAllocationItem.calculating'
        })}
      </Typography>
    </div>
  );
};

ResourceRequestMatchItemLoading.propTypes = {
  dataQeId: PropTypes.string
};

export default ResourceRequestMatchItemLoading;
